<template>
    <div>
        <header-portrate />
        <div style="margin-bottom:70px;">
            <tabs-comp :tabs="tabs" />
            <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;margin-top:100px !important;`">
                <v-col cols="12" v-for="tpl in templates" :key="tpl.key" style="margin-bottom:14px;">
                    <div style="border:1px solid #555;border-radius:10px;padding:14px;">
                        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
                            <label style="font-weight:bold;font-size:1.05rem;">{{ tpl.label }}</label>
                            <div style="display:flex;align-items:center;">
                                <span v-if="savedKey === tpl.key" style="color:#0a8a3f;font-size:0.9rem;margin-inline-end:10px;">{{ lang.saved || 'تم الحفظ' }}</span>
                                <template v-if="tpl.toggleable">
                                    <span style="font-size:0.85rem;color:#666;margin-inline-end:6px;">{{ tpl.enabled ? (lang.enabled || 'مفعّل') : (lang.disabled || 'معطّل') }}</span>
                                    <b-form-checkbox
                                        v-model="tpl.enabled"
                                        switch
                                        @change="toggleEnabled(tpl)"
                                    ></b-form-checkbox>
                                </template>
                            </div>
                        </div>

                        <b-form-textarea
                            v-if="tpl.placeholders.length"
                            v-model="tpl.value"
                            :ref="'ta_'+tpl.key"
                            class="inborder"
                            rows="3"
                            max-rows="20"
                        ></b-form-textarea>
                        <b-form-select
                            v-else-if="tpl.input === 'hour'"
                            v-model="tpl.value"
                            :options="hours"
                            class="inborder"
                        ></b-form-select>
                        <b-form-input
                            v-else
                            v-model="tpl.value"
                            class="inborder"
                        ></b-form-input>

                        <div v-if="tpl.hint" style="margin-top:6px;font-size:0.85rem;color:#666;">{{ tpl.hint }}</div>

                        <div v-if="tpl.placeholders.length" style="margin-top:8px;">
                            <span style="font-size:0.85rem;color:#666;margin-inline-end:6px;">{{ lang.available_variables || 'المتغيرات المتاحة:' }}</span>
                            <b-button
                                v-for="ph in tpl.placeholders"
                                :key="ph"
                                size="sm"
                                variant="outline-secondary"
                                style="margin:2px;font-size:0.8rem;padding:2px 8px;"
                                @click="insertPlaceholder(tpl, ph)"
                            >{{ phLabel(ph) }}</b-button>
                        </div>

                        <div style="text-align:end;margin-top:8px;">
                            <b-button variant="light" style="background:blue;color:#fff;width:120px;" @click="save(tpl)">{{ lang.save || 'حفظ' }}</b-button>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
        <Footer />
    </div>
</template>

<script>
import HeaderPortrate from '@/components/Header-Portrate.vue'
import Footer from '@/components/Footer.vue'
import TabsComp from '@/components/tabsComp.vue'
import axios from 'axios'
export default{
    components: {
        HeaderPortrate, Footer,
        TabsComp,
    },
    data() {
        return {
            templates: [],
            savedKey: '',
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        hours: function(){
            const t = [];
            for(let h = 0; h < 24; h++){
                t.push({ value: String(h), text: (h < 10 ? '0' : '') + h + ':00' });
            }
            return t;
        },
        tabs: function(){

            const menu = this.$store.getters['state'].menu;
            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
            const cM = localStorage.getItem('currentMenu');
            if(value.main.index == cM){
                cMenu = value.sub;
            }else if(cM == null && value.main.index == 1){
                cMenu = value.sub;
            }
            });

            let t = []
            Object.values(cMenu).forEach(value =>{

                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                      if(alicense[value.perms[0]] || value.perms[0] == 'any')
                          t.push(value)
                    }
                }
            })

            return t;
        },
    },
    methods: {
        phLabel(ph){
            return '{{' + ph + '}}';
        },
        insertPlaceholder(tpl, ph){
            tpl.value = (tpl.value || '') + this.phLabel(ph);
        },
        async getTemplates(){
            const post = new FormData();
            post.append("type","getWahaTemplates");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("lang", this.$cookies.get(this.$store.state.LangCooki));
            const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post)
            if(response && response.data && response.data.results){
                this.templates = response.data.results.data || [];
            }
        },
        async toggleEnabled(tpl){
            const post = new FormData();
            post.append("type","toggleWahaTemplateEnabled");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("lang", this.$cookies.get(this.$store.state.LangCooki));
            post.append("data[key]", tpl.key);
            post.append("data[enabled]", tpl.enabled ? 1 : 0);
            const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post)
            if(!response || !response.data || !response.data.error || response.data.error.number != 200){
                tpl.enabled = !tpl.enabled;
            }
        },
        async save(tpl){
            const post = new FormData();
            post.append("type","saveWahaTemplate");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("lang", this.$cookies.get(this.$store.state.LangCooki));
            post.append("data[key]", tpl.key);
            post.append("data[value]", tpl.value || '');
            const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post)
            if(response && response.data && response.data.error && response.data.error.number == 200){
                this.savedKey = tpl.key;
                setTimeout(() => { if(this.savedKey === tpl.key) this.savedKey = ''; }, 2000);
            }
        },
    },
    created(){
        this.getTemplates()
    }

}
</script>
